export default __webpack_public_path__ + "static/media/illustration-health-3-w@2x.8732a2b2.webp";